<div class="main-container">
  <div *ngFor="let reward of rewards">
    <div class="item" [ngClass]="{'fr-ended': !reward.status}" (click)="setAmount(reward)" matRipple [matRippleDisabled]="!reward.status">
      <div *ngIf="reward.status" class="amount">
        <app-currency-icon *ngIf="currency" [currency]="currency"></app-currency-icon> {{reward?.amount}}
      </div>
      <div *ngIf="!reward.status" class="amount">
        <span>SOLD OUT</span>
      </div>
      <div class="title">{{reward.descp}}</div>
      <div class="desc" [innerHTML]="reward.notes"></div>
    </div>
  </div>
  <div class="item" (click)="setAmount('', true)"  matRipple>
    <div class="title">ENTER YOUR OWN AMOUNT</div>
  </div>
</div>